module.exports = __webpack_public_path__ + "resources/img/img_passxpertv4_3.33d51358c915a85758dcfeda4e3b6130.png";